import React from 'react';
import styled from 'styled-components';

import { TRole } from '@src/types/course';
import UserInfo from './userInfo';
import { Avatar, BlankAvatar } from '../styled';

const MessageWrapper = styled.div`
	display: flex;
	background: #FFFFFF;
	border-radius: 4px;
	${props => (props.isReplier ? 'border-top: 1px solid #E9E9E9' : '')};
	${props => (props.isReplier ? 'padding: 20px 0px;' : 'padding: 20px 24px;')};
	${props => (props.isReplier ? '' : 'box-shadow: 0px 0px 12px 0px rgba(69, 65, 78, 0.09)')};
`;

const MainContent = styled.div`
	width: 100%;
`;

const MessageContent = styled.div`
	white-space: pre-line;
	overflow-wrap: break-word;
	word-break: break-word;
	color: #333333;

	@media ${props => props.theme.device.tablet} {
		font-size: 14px;
	}

	@media ${props => props.theme.device.smTablet} {
		font-size: 14px;
	}

	@media ${props => props.theme.device.mobile} {
		font-size: 14px;
	}
`;

interface IMessage {
	avatarLink: string;
	authorName: string;
	role: TRole;
	isReplier?: boolean;
	message: string;
	bought: boolean;
	createAt: string;
	children?: React.ReactNode;
}

const MessageItem = ({
	avatarLink, authorName, role, bought, createAt, isReplier, message, children,
}: IMessage): JSX.Element => (
	<MessageWrapper isReplier={isReplier}>
		{avatarLink ? (
			<Avatar src={avatarLink} alt="" isReplier={isReplier} />
		) : (
			<BlankAvatar width={isReplier ? 40 : 60} height={isReplier ? 40 : 60} />
		)}
		<MainContent>
			<UserInfo
				role={role}
				name={authorName}
				createAt={createAt}
				bought={bought}
			/>
			<MessageContent>{message}</MessageContent>
			{children}
		</MainContent>
	</MessageWrapper>
);

export default MessageItem;
